import React, { memo, useEffect } from 'react';
import Navbar from './navbar/Navbar';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './footer/Footer';
import { AuthProvider } from './AuthProvider.jsx';
import {RichTextEditor} from "@components/common/rich-text-editor/index.js";


function Layout(props) {
    const location = useLocation();
    const isContentPage = /^\/publication\/content/.test(location.pathname);


    useEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
      <div className='flex flex-col min-h-screen'>
          <header className={'sticky top-0 z-[60]'}>
              <Navbar/>
          </header>
          <main className={`flex-grow w-full ${(location.state && location.state.url) || isContentPage ? 'overflow-hidden' : `mx-auto desktop:px-6 max-w-[1440px] `}`}>
                 <AuthProvider>
                     <Outlet />
                 </AuthProvider>
          </main>

            {!isContentPage && <footer className='w-full' id={'footer'}>
                <Footer/>
            </footer>}
      </div>
    );
}

export default memo(Layout);
